<template>
    <div
      :class="sensorActive ? 'horizontal-layout horizontal-menu navbar-sticky footer-static sensor-active' : 'horizontal-layout horizontal-menu navbar-sticky footer-static'">
      <div class="main-page overflow-hidden position-relative">
        <div class="content-full">

          <!-- Navbar -->
          <Navbar v-if="navbarStatus" />
          <!--/ Navbar -->

          <router-view/>

        </div>
        <!-- Footer -->
        <Footer :class="sensorActive ? 'd-none' : 'footer footer-light footer-static'"/>
        <!--/ Footer -->
        <!-- Background -->
        <Background/>
        <!--/ Background -->
      </div>
    </div>
</template>

<script>

// import Loader from '@/views/frontend/components/Loader.vue'
import Navbar from '@/views/frontend/components/navbar/Navbar.vue'
import Background from '@/views/frontend/components/Background.vue'
import Footer from '@/views/frontend/components/Footer.vue'

export default {
  components: {
    Navbar,
    Background,
    Footer,
  },
  data() {
    return {
      fullscreen: false,
      sensorActive: false,
      navbarStatus: false,
    }
  },
  methods: {
  },
  created() {
    if (this.$route.query.sensor && this.$route.query.sensor === 'active') {
      this.sensorActive = true
      this.navbarStatus = false
    } else {
      this.sensorActive = false
      this.navbarStatus = true
    }
  },
  mounted() {
    if (this.sensorActive === true) {
      document.body.classList.add('sensor-active')
      if (this.$route.name === 'packages') {
        this.navbarStatus = true
      } else {
        this.navbarStatus = false
      }
    }
  },
  updated() {
    if (this.sensorActive === true) {
      if (this.$route.name === 'packages') {
        this.navbarStatus = true
      } else {
        this.navbarStatus = false
      }
    }
  },
}
</script>

<style>
* {
  outline: 0 !important;
}

body {
  background-color: #fff !important;
}

body.sensor-active .modal {
  padding-bottom: 270px;
}
body.sensor-active .card-body span.text-ellipsis {
  width: auto !important;
}
.carousel-indicators li {
  width: 8px !important;
  height: 8px !important;
  opacity: 1 !important;
  border-radius: 8px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  transition: all .3s;
}

.carousel-indicators li.active {
  background-color: #2d2e9b;
  width: 15px !important;
}

.navbar a, .right-menu a {
  color: #4b4b4b !important;
}

.navbar a:hover, right-menu a:hover {
  color: #2d2e9b !important;
}

.main-page {
  min-height: 100vh;
}

.main-page.keyboard-active {
  padding-bottom: 100px;
}

.min-vh-100-nf {
  min-height: calc(100vh - 180px);
}

@media (max-width: 989px) {
  .main-page {
    padding-bottom: 100px;
  }
  .nav {
    margin-top: 25px;
  }
  .nav a {
    display: block !important;
    padding: 10px 0 !important;
  }
}
.sensorActive .vs__dropdown-toggle {
  border: 2px solid #2d2e9b !important;
}
.v-select:not(.vs--single) .vs__deselect svg,
.sensorActive .vs__dropdown-toggle svg {
 fill: #fff !important;
}
.v-select{
  background-color: #fff;
  border-radius: 5px;
}
</style>
